import { atom } from 'jotai';
import { atomFamily, atomWithStorage } from 'jotai/utils';
import type { BlockAnalytics } from '@/api/nest-apis/analytics-api';
import type { AnalyticsStats } from '@/api/nest-apis/analytics-api';
import type { ShareTab } from '@/components/core/common/Modals/ShareVersion/types';
import type { GatedExportFormat } from '@/utils/billing';
import { atomKeys } from './atom-keys';

export const stringAtomFamily = atomFamily((defaultValue: string) => {
  const updatedValue = defaultValue?.split('_')?.slice(1)?.join('_') || '';
  return atom(updatedValue);
});
export const numberAtomFamily = atomFamily(() => atom<number>(0));
export const defaultTrueBooleanAtomFamily = atomFamily(() => atom<boolean>(true));
export const defaultFalseBooleanAtomFamily = atomFamily(() => atom<boolean>(false));
export const objectAtomFamilyWithStorage = atomFamily((value: string) =>
  atomWithStorage<any>(value, {}),
);
export const objectAtomFamily = atomFamily(() => atom<any>({}));
export const arrayAtomFamily = atomFamily(() => atom<any[]>([]));
// export const arrayAtomFamily = atomFamily((value: string) => atomWithStorage<any[]>(value, []));

export const blockCommentSummaryAtom = atom((get) => {
  const comments = get(arrayAtomFamily(atomKeys.comments)) as BlockComment[];
  const summary: Record<string, { open: number; total: number }> = {};

  for (const comment of comments) {
    if (comment.parentCommentId || !comment.blockId) continue;
    const entry = (summary[comment.blockId] ??= { open: 0, total: 0 });
    entry.total += 1;
    if (comment.status !== 'closed') entry.open += 1;
  }

  return summary;
});

export const showBlockStatsOverlayAtom = atom(false);
export const blockStatsAtom = atom<Record<string, BlockAnalytics>>({});
export const proposalStatsAtom = atom<AnalyticsStats | null>(null);
export const builderSidebarOpenSideAtom = atom<'left' | 'right' | ''>('');
export const shareVersionTabAtom = atom<ShareTab>('live');
// `source` is the export surface the upgrade modal replaced; dismissing reopens it.
export const exportUpgradeAtom = atom<{
  format: GatedExportFormat;
  source: 'share-modal' | 'export-modal';
} | null>(null);
// Free workspaces see the plans modal instead of the Team page link.
export const plansModalOpenAtom = atom(false);
// Where checkout from the plans modal comes back to. Billing when null.
export const plansCheckoutReturnUrlAtom = atom<string | null>(null);
export const pageLimitUpgradeOpenAtom = atom(false);
export const clipboardAtom = atom<{ type: 'block' | 'content' | 'fillable'; item: any } | null>(
  null,
);
